import { useMemo } from "react";

import { useAppSelector } from "@/hooks/redux";

export const useUserPayload = () => {
    const {
        id: userId,
        firstName,
        lastName,
        phone,
    } = useAppSelector((state) => state.user);

    const userPayload = useMemo(
        () => ({
            userId,
            phone,
            fullname: `${firstName} ${lastName}`,
        }),
        [userId, phone, firstName, lastName],
    );

    return { userPayload };
};
